export default (postalCode: string) => {
  return `${postalCode.substring(0, 5)}-${postalCode.substring(5, 8)}`;
};
